import { useEffect } from "react";

type EnlargedCardModalModuleProps = {
    enlargedCard: any,
    setEnlargedCard: (obj: any) => void,
}
export default function EnlargedCardModalModule({ enlargedCard, setEnlargedCard }: EnlargedCardModalModuleProps) {
    // ESC key to close
    useEffect(() => {
        const handleEsc = (e: any) => {
            if (e.key === "Escape") setEnlargedCard(null);
        };
        if (enlargedCard) window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [enlargedCard, setEnlargedCard]);
    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 shadow-xl max-w-md w-full relative">
                <button
                    className="absolute top-4 right-4 text-slate-600 hover:text-black text-xl"
                    onClick={() => setEnlargedCard(null)}
                >
                    &times;
                </button>

                <h2 className="text-lg font-semibold mb-4 text-center">{enlargedCard.label}</h2>
                <p className="text-4xl font-bold mb-2 text-center">{enlargedCard.value}</p>
                <p className="text-sm text-emerald-600 mb-6 text-center">Trend: {enlargedCard.trend} siste 30 dager</p>

                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-xs text-slate-600 mb-6">
                    <p className="mb-1">Dette er en detaljvisning for KPI-en du klikket på.</p>
                    <p>
                        I produksjon kan denne flaten kobles mot Chamcore-rapportene for å vise historiske tall, per agent,
                        per kanal eller per produkt.
                    </p>
                </div>

                <div className="flex justify-end">
                    <button
                        className="px-4 py-2 rounded-full text-sm bg-slate-900 text-white hover:bg-black"
                        onClick={() => setEnlargedCard(null)}
                    >
                        Lukk
                    </button>
                </div>
            </div>
        </div>
    )
}